import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
import { FetchResultType } from "../fetchTypes";

export const getReactAppParameters = createAsyncThunk(
    "/reactAppParameters/get",
    async (_, { rejectWithValue }) => {
        try {
            const { data, errorMessage, isSuccess } = await commonNetwork.get("/parameters/react-app-parameters");
            console.log("getReactAppParameters data", data);
            if (isSuccess) {
                return data;
            } else {
                return rejectWithValue(data);
            }
        } catch (e: any) {
            return rejectWithValue(e.data.message);
        }
    }
);

export type ReactAppParameterType = {
    react_app_client_id: string,
    react_app_client_secret: string,
    react_app_api_key: string,
    react_app_api_secret: string,
}

export interface reactAppParameterStateType extends FetchResultType {
    reactAppParameters: ReactAppParameterType,
}
export const reactAppParameterSlice = createSlice({
    name: "reactAppParameters",
    initialState: {
        reactAppParameters: {},
        isFetching: true,
        isSuccess: false,
        isError: false,
        errorMessage: "",
    },
    reducers: {
        clearState: (state) => {
            state.reactAppParameters = {};
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = false;
            return state;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getReactAppParameters.fulfilled, (state, { payload }) => {
            state.reactAppParameters = payload;
            state.isFetching = false;
            state.isSuccess = true;
            state.isError = false;
            return state;
        });
        builder.addCase(getReactAppParameters.rejected, (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            state.reactAppParameters = {};
        });
        builder.addCase(getReactAppParameters.pending, (state) => {
            state.isFetching = true;
        });
    },
});
export const { clearState } = reactAppParameterSlice.actions;

export const reactAppParameterSelector = (state: any) => state.reactAppParameters.reactAppParameters;

export const reactAppParameterReducer = reactAppParameterSlice.reducer;
